<style scoped></style>

<template>
  <div style="display: flex; flex-direction: column;background-color: #FFF;">
    <fm-title title-text="工资发布" @clickTitleMenu="clickTitleMenu" :title-menus="titleMenus">
      <div style="display: flex; align-items: center;">
        <Tag v-for="item in sumTotal" :key="item.key" :color="item.color">{{ item.label }}: ¥{{ item.value.toFixed(2) }}</Tag>
      </div>
    </fm-title>
    <i-input style="width: 300px; margin: 0 10px;" placeholder="请输入名字或代码搜索" search @on-search="key => (searchKey = key, page.num = 1)" @on-clear="searchKey = null, page.num = 1" clearable>
      <span slot="prepend">搜索</span>
    </i-input>
    <div class="data-list" ref="content" style="margin-top: 10px; flex: 1; height: 0;">
      <Table ref="table" :loading="loading.load" :data="pageDataList" :columns="columns" :height="tableHeight" show-summary :summary-method="detailTableSum">
        <template slot-scope="{ row }" slot="action">
          <Button v-if="$authFunsProxyNoRoute['performance.wages.manage.index-editDetail']" icon="ios-brush" type="text" size="small" style="margin-right: 5px" @click="itemEdit(row)">修改</Button>
          <Poptip v-if="$authFunsProxyNoRoute['performance.wages.manage.index-delDetail']" transfer confirm @on-ok="itemDel(row)" title="确定删除吗？">
            <Button icon="md-trash" size="small" type="text">删除</Button>
          </Poptip>
        </template>
      </Table>
    </div>
    <div style="padding: 10px;background-color: #FFF;">
      <Page @on-change="val => page.num = val" :total="searchDataList.length" :current="page.num" :page-size="page.size" show-total show-elevator />
    </div>
    <Drawer draggable :mask-closable="false" mask transfer title="工资修改" width="40" placement="right" closable v-model="status.form">
      <DrawerAction v-if="chooseData" :loading="loading.submit" @confirm="submitEdit" @cancel="status.form = false">
        <Form :label-width="80">
          <FormItem v-for="item in formItems" :key="item.key" :label="item.label">
            <Input type="number" v-model="chooseData[item.key]" :placeholder="'请输入' + item.label" />
          </FormItem>
        </Form>
      </DrawerAction>
    </Drawer>
    <Drawer draggable :mask-closable="false" mask transfer title="工资上传" width="40" placement="right" closable v-model="status.upload">
      <data-upload @success="dataUpload" />
    </Drawer>
    <input type="file" @change="batchUpdate" style="display: none;" ref="batchFile" />
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { request } from '@/api'
import DrawerAction from '../../../../components/drawer/action.vue'
import { detailTableSum } from '../lib'
import DataUpload from './upload.vue'

export default {
  components: { DrawerAction, DataUpload },
  data () {
    return {
      dataList: [],
      loading: {
        load: false,
        submit: false
      },
      page: {
        size: 30,
        num: 1
      },
      searchKey: null,
      tableHeight: null,
      configList: [],
      chooseData: null,
      status: {
        form: false,
        upload: false
      }
    }
  },
  computed: {
    detailTableSum () {
      const data = this.dataList
      return ({ columns }) => detailTableSum({ columns, data })
    },
    sumTotal () {
      const configList = this.configList
      const dataList = this.dataList
      const columns = [
        { label: '应发工资', color: 'geekblue' },
        { label: '应扣工资', color: 'volcano' },
        { label: '实发工资', color: 'blue' }
      ].map(col => {
        const config = configList.find(v => v.valueLabel === col.label)
        return config ? {
          color: col.color,
          label: config.valueLabel,
          key: config.valueKey,
          value: 0,
        } : null
      }).filter(v => v !== null)
      dataList.forEach(item => {
        columns.forEach(col => {
          const value = Number(item[col.key])
          if (!isNaN(value)) {
            col.value += value
          }
        })
      })
      return columns
    },
    searchDataList () {
      const searchKey = this.searchKey
      if (searchKey) {
        return this.dataList.filter(v => String(v.code).indexOf(searchKey) > -1 || String(v.wageWorkerName).indexOf(searchKey) > -1)
      }
      return this.dataList
    },
    pageDataList () {
      const start = (this.page.num - 1) * this.page.size
      const end = start + this.page.size
      return this.searchDataList.slice(start, end)
    },
    titleMenus () {
      const dataList = this.dataList
      return [
        { key: 'back', label: '返回' },
        { key: 'reload', label: '刷新', fun: 'getDetail' },
        { key: 'usePrevious', label: '使用上月数据生成', fun: 'uploadDetail', show: dataList.length === 0 },
        { key: 'batchUpdate', label: '批量更新', fun: 'uploadDetail', show: dataList.length > 0 },
        { key: 'upload', label: '上传数据', fun: 'uploadDetail', show: dataList.length === 0 },
        { key: 'reUpload', label: '重新上传数据', fun: 'uploadDetail', show: dataList.length > 0 },
        { key: 'clear', label: '清除数据', fun: 'delDetail' },
        { key: 'end', label: '发布', fun: 'switchStatus' }
      ].filter(v => {
        return v.show !== false && (!v.fun || this.$authFunsProxyNoRoute['performance.wages.manage.index-' + v.fun])
      })
    },
    columns () {
      const configList = this.configList
      return [
        { key: 'code', title: '代码', width: 100, fixed: 'left' },
        { key: 'wageWorkerName', title: '姓名', width: 100, fixed: 'left' },
        ...configList.map(v => {
          return { key: v.valueKey, title: v.valueLabel, minWidth: 100 }
        }),
        { key: 'action', title: '操作', slot: 'action', width: 180, fixed: 'right' }
      ]
    },
    formItems () {
      return this.configList.filter(v => v.canEdit).map(item => {
        return {
          key: item.valueKey,
          label: item.valueLabel
        }
      })
    }
  },
  methods: {
    dataUpload () {
      this.status.upload = false
      this.loadData()
    },
    async batchUpdate () {
      if (this.$refs.batchFile.files.length) {
        try {
          if (!this.dataList.length) {
            throw new Error('暂无数据，无法更新')
          }

          const buffer = await this.$refs.batchFile.files[0].arrayBuffer()
          const workbook = XLSX.read(buffer, {
            type: 'array',
            cellDates: true
          })
          const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
            defval: null
          }).filter(v => v['姓名'] && v['代码'])
          if (!data.length) {
            throw new Error('未从表格中获取到有效数据，请检查是否正确填写姓名和代码列')
          }

          let noExistCols = []
          const xlsCols = Object.keys(data[0])
          const withConfigCols = xlsCols.map(xlsCol => {
            const configCol = this.configList.find(v => v.valueLabel === xlsCol)
            if (configCol) {
              return {
                label: configCol.valueLabel,
                key: configCol.valueKey
              }
            } else if (xlsCol === '代码') {
              return { label: xlsCol, key: 'code' }
            } else if (xlsCol === '姓名') {
              return { label: xlsCol, key: 'name' }
            } else {
              return null
            }
          })

          if (noExistCols.length) {
            throw new Error('表格中以下字段未找到系统中所匹配的字段：' + noExistCols.join("、") + '，请检查字段名是否正确')
          }
          
          // console.log(withConfigCols)
          const dataList = data.map(item => {
            let obj = {}
            withConfigCols.forEach(({ label, key }) => {
              obj[key] = item[label] || 0
            })
            return obj
          })
          // console.log(data)
          // console.log(dataList)
          const res = await request('/performance/wage_month_worker/batch', 'post', {
            wageMonthId: this.$route.params.monthData.id,
            dataList,
            checkOmit: 0
          })
          if (res.success === 1) {
            this.$Message.success('已更新')
            this.loadData()
          } else {
            const err = res.dataList.filter(v => v.isError).map(v => v.name + ': ' + v.error).join("\n")
            this.$Modal.error({
              title: '操作失败', render (h) {
                return h('div', {
                  style: {
                    whiteSpace: 'pre-wrap',
                    maxHeight: '50vh',
                    overflow: 'auto'
                  }
                }, err)
              }
            })
          }
        } catch (e) {
          this.$Modal.error({ title: '操作失败', content: e.message })
        }
        this.$refs.batchFile.value = null
      }
    },
    async dataClear () {
      try {
        await request('/performance/wage_month/clear/' + this.$route.params.monthData.id, 'post')
        this.$Message.success('已清除')
        this.loadData()
      } catch (e) {
        this.$Modal.error({ title: '操作失败', content: e.message })
      }
    },
    async clickTitleMenu (key) {
      if (key === 'back') {
        this.$router.back()
      } else if (key === 'clear' && await this.$confirm({ title: '确定清除吗？' })) {
        this.dataClear()
      } else if (key === 'end' && await this.$confirm({ title: '确定发布吗？' })) {
        await request('/performance/wage_month/status/' + this.$route.params.monthData.id, 'post', {
          status: 'end'
        })
        this.$router.replace({
          name: 'performance.wages.manage.detail',
          query: { id: this.$route.params.monthData.id }
        })
      } else if (key === 'reload') {
        this.loadData()
      } else if (key === 'upload') {
        this.status.upload = true
      } else if (key === 'reUpload') {
        if (await this.$confirm({ title: '如需重新上传数据，请先清除当前数据', content: '确定清除所有数据吗？' })) {
          await this.dataClear()
          this.loadData()
          this.status.upload = true
        }
      } else if (key === 'usePrevious') {
        this.usePrevious()
      } else if (key === 'batchUpdate') {
        this.$refs.batchFile.click()
      }
    },
    async usePrevious () {
      if (await this.$confirm({ title: '确定使用上月数据生成吗？' })) {
        try {
          await request('/performance/wage_month/copy/' + this.$route.params.monthData.id, 'post', {
            type: 'real', month: (new this.$datetime.Date(this.$route.params.monthData.month + '-01')).compute('M', -1).format('Y-M')
          })
          this.$Message.success('已生成')
          this.loadData()
        } catch (e) {
          this.$Modal.error({ title: '操作失败', content: e.message })
        }
      }
    },
    async submitEdit () {
      this.loading.submit = true
      try {
        await request('/performance/wage_month_worker', 'post', this.chooseData)
        this.$Message.success('已修改')
        this.loadData()
        this.status.form = false
      } catch (e) {
        this.$Modal.error({ title: '修改失败', content: e.message })
      }
      this.loading.submit = false
    },
    itemEdit (row) {
      this.chooseData = JSON.parse(JSON.stringify(row))
      this.status.form = true
    },
    async itemDel (row) {
      try {
        await request('/performance/wage_month_worker/' + row.id, 'delete')
        this.loadData()
        this.$Message.success('已删除')
      } catch (e) {
        this.$Modal.error({
          title: '删除失败', content: e.message
        })
      }
    },
    async loadData () {
      if (!this.$authFunsProxyNoRoute['performance.wages.manage.index-getDetail']) {
        return
      }
      this.loading.load = true
      try {
        const configList = await request('/performance/wage_month/worker_config/' + this.$route.params.monthData.id, 'get')
        this.configList = configList.sort((a, b) => {
          if (a.sortNum === null) {
            return 1
          } else {
            return a.sortNum - b.sortNum
          }
        })
        this.dataList = await request('/performance/wage_month_worker', 'get', {
          wageMonthId: this.$route.params.monthData.id
        })
      } catch (e) {
        this.$Modal.error({
          title: '加载失败', content: e.message, onOk: this.$router.back()
        })
      }
      this.loading.load = false
    },
    resize () {
      this.tableHeight = this.$refs.content.offsetHeight - 48
    },
  },
  async mounted () {
    window.addEventListener('resize', this.resize)
    this.resize()
    this.loadData()
  },
  destroyed () {
    this.dataList = []
    window.removeEventListener('resize', this.resize)
  }
}
</script>
